import snackBarUpdate from "../../actions/snackBarActions";
import Prefix from "../../config/ApiPrefix";
import AXIOS from "../../config/Axios";
import SecureStorage from "../../config/SecureStorage";
import { ACTIONS } from "../interfaces/index";
// import { AnyLengthString } from "aws-sdk/clients/comprehend";

export const handleError = (dispatch: any, err: any) => {
  let title = "";
  if (err.response) {
    title = err.response.data.error;
    if (err.response.data.message) {
      title = String(err.response.data?.message).replace(/"|{|}|[|]/g, "");
    }
  } else {
    title = "Something went wrong!";
  }
  snackBarUpdate({
    payload: {
      message: title || "Something went wrong",
      status: true,
      type: "error",
    },
  })(dispatch);
  dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  throw err;
};
export const getAuthHeader = () => {
  const token = SecureStorage.getItem("token");
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

export const changePassword = (body: any) => async (
  dispatch: Function
) => {
  try {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    await AXIOS.post(`${Prefix.api}/auth/password_reset/reset_password/`,
      body,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      });
    dispatch({ type: ACTIONS.CHANGE_PASSWORD, payload: null });
    snackBarUpdate({
      payload: {
        message: "Password Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  } catch (err: any) {
    let title = "";
    if (err.response) {
      title = String(err.response.data?.errors?.error);
    } else {
      title = "Something went wrong!";
    }
    snackBarUpdate({
      payload: {
        message: title || "Something went wrong",
        status: true,
        type: "error",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    throw err;
  }
};
export const getUserDetails = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(`${Prefix.sso}/auth/shortprofile/`, {
      headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
    });
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: data });
  } catch (err: any) {
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: [] });
    handleError(dispatch, err);
  }
};
export const getBookingOverview = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
      const { data } = await AXIOS.get(
          `${Prefix.api}/booking/ccge_booking_count/${url ? `?${url}` : ""}`,
          { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
      );
      dispatch({ type: ACTIONS.GET_BOOKING_OVERVIEW, payload: data });
  } catch (err: any) {
      let title = "";
      if (err.response) {
          title = err.response?.data?.errors;
      } else {
          title = "Something went wrong!";
      }
      snackBarUpdate({
          payload: {
              message: title || "Something went wrong",
              status: true,
              type: "error",
          },
      })(dispatch);
      dispatch({ type: ACTIONS.SET_LOADING, payload: false });
      throw err;
  }
};
